import { z } from 'zod';
export const MembershipRoleSchema = z.enum([
    'OWNER',
    'TENANT_ADMIN',
    'BRANCH_MANAGER',
    'MEMBER',
]);
export const MembershipStatusSchema = z.literal('ACTIVE');
export const AuthorizedBranchContextSchema = z.object({
    id: z.string().uuid(),
    name: z.string().min(1),
}).strict();
export const AuthorizedOrganizationContextSchema = z.object({
    id: z.string().uuid(),
    name: z.string().min(1),
}).strict();
export const AuthorizedMembershipContextSchema = z.object({
    organization: AuthorizedOrganizationContextSchema,
    membershipId: z.string().uuid(),
    role: MembershipRoleSchema,
    status: MembershipStatusSchema,
    branches: z.array(AuthorizedBranchContextSchema).min(1),
}).strict();
export const CurrentActorProfileSchema = z.object({
    actorId: z.string().uuid(),
    displayName: z.string().min(1).nullable(),
}).strict();
export const CurrentActorContextSchema = z.object({
    profile: CurrentActorProfileSchema,
    memberships: z.array(AuthorizedMembershipContextSchema).min(1),
}).strict();
export const CurrentActorContextResponseSchema = z.object({
    success: z.literal(true),
    data: CurrentActorContextSchema,
}).strict();
//# sourceMappingURL=identity.js.map